<template>
  <div class="container">
    <table class="table-list" cellspacing="0">
      <caption>
        TECENTRIQ 具有安全並且持久的治療反應
      </caption>
      <thead>
        <tr>
          <th>治療相關副作用</th>
          <th>All grade, %</th>
          <th>Grade 3–4, %</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, key) in dataRow" :key="key">
          <td title="治療相關副作用">{{row.col1}}</td>
          <td title="All grade, %">{{row.col2}}</td>
          <td title="Grade 3–4, %">{{row.col3}}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">
            <small>
              *Reported in ≥4 patients (any grade) or ≥2 patients (Grade 3–4).
              Multiple occurrences of the same event were counted once at maximum severity Data cut-off:
              4 July 2016; median follow-up: 17.2 months.
            </small>
          </td>
        </tr>
      </tfoot>
    </table>
    <div class="footerText">
      Balar et al. Lancet 2017
    </div>
    <template>
      <router-link to="/step4-2" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link
      to="/step5-2" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'page2',
  data () {
    return {
      dataRow: [
        {
          'col1': '所有治療相關副作用',
          'col2': '66',
          'col3': '16'
        },
        {
          'col1': '疲勞',
          'col2': '30',
          'col3': '3'
        },
        {
          'col1': '腹瀉',
          'col2': '12',
          'col3': '2'
        },
        {
          'col1': '瘙癢',
          'col2': '11',
          'col3': '1'
        },
        {
          'col1': '食慾下降',
          'col2': '9',
          'col3': '1'
        },
        {
          'col1': '甲狀腺功能低下',
          'col2': '7',
          'col3': '0'
        },
        {
          'col1': '貧血',
          'col2': '5',
          'col3': '1'
        },
        {
          'col1': '發冷',
          'col2': '5',
          'col3': '0'
        },
        {
          'col1': '噁心',
          'col2': '5',
          'col3': '0'
        },
        {
          'col1': '發熱',
          'col2': '5',
          'col3': '0'
        },
        {
          'col1': '皮疹',
          'col2': '5',
          'col3': '1'
        },
        {
          'col1': '嘔吐',
          'col2': '5',
          'col3': '0'
        },
        {
          'col1': '皮疹，斑丘疹',
          'col2': '4',
          'col3': '0'
        },
        {
          'col1': 'ALT上升',
          'col2': '4',
          'col3': '3'
        },
        {
          'col1': '關節痛',
          'col2': '4',
          'col3': '0'
        },
        {
          'col1': 'AST上升',
          'col2': '3',
          'col3': '3'
        },
        {
          'col1': '膽紅素上升',
          'col2': '3',
          'col3': '2'
        },
        {
          'col1': '低磷酸鹽血症',
          'col2': '3',
          'col3': '2'
        },
        {
          'col1': '鹼性磷酸酶上升',
          'col2': '3',
          'col3': '1'
        },
        {
          'col1': '呼吸困難',
          'col2': '3',
          'col3': '0'
        },
        {
          'col1': '輸注相關反應',
          'col2': '3',
          'col3': '0'
        },
        {
          'col1': '淋巴細胞數量下降',
          'col2': '3',
          'col3': '0'
        },
        {
          'col1': '腎功能衰竭',
          'col2': '2',
          'col3': '2'
        }
      ]
    }
  }
}
</script>

<style scoped>
a[class*="btn-"]{
  background:#b6798e;color:white;
}
.btn-next {right:0;}
@media(max-width:750px){
    .container {width:90%;margin-left:5%;}
}
</style>



// WEBPACK FOOTER //
// src/components/step5/page2.vue